import Select from '@components/v2/form/Select/Select';
import CheckboxMenuItem from '@components/v2/ui/Menu/CheckboxMenuItem';
import { SelectChangeEvent } from '@mui/material';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import LangEnum from '../../lang/LangEnum';
import { useApplicationContext } from '../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../translation/TranslationContext';
import { BrandSplitSettings } from './brandSplitSettings.types';

type BrandSplitSelectProps = {
  splitSettings: BrandSplitSettings[];
  selectedSplitSettings: string[];
  onChange: (newSelectedSplitSettingsKeys: string[]) => void;
};

const BrandSplitSelect = ({
  splitSettings,
  selectedSplitSettings,
  onChange,
}: BrandSplitSelectProps) => {
  const { translate } = useTranslation();
  const { state } = useApplicationContext();
  const { isEnableAdminChangeSplitSettings } = useFeatureFlag();

  const enable = state.isAdminTeceo || isEnableAdminChangeSplitSettings;

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    onChange(event.target.value as string[]);
  };

  return (
    <Select
      multiple
      label={translate(LangEnum.ORDER_SPLIT_TYPES)}
      value={selectedSplitSettings}
      disabled={!enable}
      multipleProps={{
        getChipConfig: (value) => ({
          label: splitSettings.find((split) => split.key === value)?.label,
        }),
      }}
      onChange={handleChange}
    >
      {splitSettings.map((split) => (
        <CheckboxMenuItem
          key={split.key}
          value={split.key}
          selected={selectedSplitSettings.includes(split.key)}
        >
          {split.label}
        </CheckboxMenuItem>
      ))}
    </Select>
  );
};

export default BrandSplitSelect;
